export default __webpack_public_path__ + "be35026cb938d231dff85d274901e259.svg";